import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAuth } from "../../../../auth/useAuth";
import { useBookmarkContext } from "../../../../hooks/useBookmarkContext";
import { useCustomer } from "../../../../auth/useCustomer";

import "./BookmarkButton.scss";

function BookmarkButton({ onClick }) {
	const { currentUser } = useAuth();
	const { bookmarkItems } = useBookmarkContext();
	const CustomerContext = useCustomer();

	const hasCustomer = !!CustomerContext.customer;

	if (!currentUser) {
		return (<></>);
	}
	const organization_member_data = JSON.parse(localStorage.getItem('organization_member:data'));
	const organization = organization_member_data?.organization || false;
	const bookmarksEnabled = organization?.features?.catalog?.lists?.bookmarks !== false;
	if (!bookmarksEnabled) {
		return (<></>);
	}

	return (
		<OverlayTrigger placement="bottom" overlay={
			<Tooltip className="_boss tooltip">Bookmarks</Tooltip>
		}>
			<div
				data-component="BookmarkButton"
				className={[hasCustomer && "customer-signed-in", bookmarkItems?.length && "has-bookmarks"].filter(c => c).join(" ")}
			>
				<Button
					type="button"
					variant="link"
					onClick={e => onClick?.(e)}
				></Button>
			</div>
		</OverlayTrigger>
	);
}

export default BookmarkButton;